import { render, staticRenderFns } from "./ExitToApp.vue?vue&type=template&id=c3348bbe"
import script from "./ExitToApp.vue?vue&type=script&lang=js"
export * from "./ExitToApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports